import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import NotificationContainer from '@/components/ui/NotificationContainer';

// Pages
import HomePage from '@/pages/HomePage';
import NewStrategySessionPage from '@/pages/NewStrategySessionPage';
import AnalysisPage from '@/pages/AnalysisPage';
import DocumentPage from '@/pages/DocumentPage';

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        <Route path="/" element={<Navigate to="/strategy" replace />} />
        <Route path="/strategy" element={<HomePage />} />
        <Route path="/strategy/:sessionKey" element={<NewStrategySessionPage />} />
        <Route path="/strategy/:sessionKey/analysis/:analysisId" element={<AnalysisPage />} />
        <Route path="/strategy/:sessionKey/document/:documentId" element={<DocumentPage />} />
        <Route path="*" element={<Navigate to="/strategy" replace />} />
      </Routes>

      <NotificationContainer />
    </div>
  );
};

export default App;